import { reducers as createRootReducer } from 'ducks';
import { createStore as _createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { routerMiddleware } from 'connected-react-router'
import promiseMiddleware from './middlewares/promiseMiddleware';

const composeEnhancers = (process.env.NODE_ENV !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const createStore = (history) => {
  return _createStore(
    createRootReducer(history),
    composeEnhancers(
      applyMiddleware(thunk),
      applyMiddleware(promiseMiddleware),
      applyMiddleware(routerMiddleware(history))
    )
  );
};

export default createStore;



// WEBPACK FOOTER //
// ./src/utils/createStore.js